export const REALMS = [
  { slug: 'the-deep', numeral: 'I', name: 'The Deep', subtitle: 'The ocean answered.', sigil: '/realms/sigil-deep.webp' },
  { slug: 'the-descent', numeral: 'II', name: 'The Descent', subtitle: 'The abyss remembered.', sigil: '/realms/sigil-descent.webp' },
  { slug: 'the-arrival', numeral: 'III', name: 'The Arrival', subtitle: 'The heavens welcomed.', sigil: '/realms/sigil-arrival.webp' },
  { slug: 'the-allure', numeral: 'IV', name: 'The Allure', subtitle: 'Desire became sacred.', sigil: '/realms/sigil-allure.webp' },
];

export const getRealm = (slug) => REALMS.find((r) => r.slug === slug);
